import * as React from "react";
import { makeStyles, Spinner, Text } from "@fluentui/react-components";
import { flexColumn, intro } from "../../styles/GlobalStyles";
import { useParams } from "react-router-dom";
import { fetchPublicRecord } from '../../util/FormUtils';
import { PublicPublisher } from "../../dto/PublicPublisher";
import { useGlobalDispatch } from "../../state/GlobalStateProvider";
import { CenteredContent } from "../../components/CenteredContent";
import { ProductCard } from "./ProductCard";

const entitySet = "publishers";

const useStyles = makeStyles({
    container: {
        ...flexColumn,
        width: "100%"
    },
    intro
});

export const PublisherPage: React.FC = React.memo(() => {
    const styles = useStyles();
    const { publisherId } = useParams();
    const globalDispatch = useGlobalDispatch();

    const [record, setRecord] = React.useState<PublicPublisher>({} as PublicPublisher);

    React.useEffect(() => { fetchPublicRecord(publisherId, entitySet, setRecord, globalDispatch); }, [publisherId, globalDispatch]);

    if (!record.guid)
    {
        return (
            <CenteredContent>
                <Spinner />
            </CenteredContent>
        );
    }
    else
    {
        return (
            <>
                <div className={styles.container}>
                    <p>
                        <CenteredContent>
                            <Text className={styles.intro}>
                                {record?.name}
                            </Text>
                        </CenteredContent>
                    </p>

                    { record?.products?.map(p => <ProductCard key={p.guid} product={p} />) }
                </div>
            </>
        );
    }
});